import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { PaperKbdComponent } from '@ricoh-paper/angular';
import { getInitials } from '../../../../../../core/utils/text';
import type { CmdkPersonItem } from '../../models/cmdk.model';
import { PersonColourDirective } from '../../../../../../shared/people/person-colour';
import { CallPresenceDotComponent } from '../../../../../calls/dock/call-presence-dot.component';

/**
 * A person row.
 *
 * The leading mark is a round avatar rather than the square plate every other
 * kind uses. That is not decoration: roundness is the one shape cue that says
 * "this is a human" at a glance in a mixed list, and the palette's list is
 * always mixed.
 *
 * The search returns where someone is SITTING today, not whether they are in
 * the office, so no dot is ever derived from a desk booking: the booking is the
 * trailing location line, which is what it actually is. The dot on the avatar
 * is Flow Live's presence (`presenceChanged`, `im-call-presence-dot`), drawn only
 * with `flow.calls` on: in a call, in the office, at home or elsewhere, out.
 */
@Component({
  selector: 'im-cmdk-row-person',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [PaperKbdComponent, PersonColourDirective, CallPresenceDotComponent],
  templateUrl: './cmdk-row-person.component.html',
  styleUrl: './cmdk-row-person.component.scss',
})
export class CmdkRowPersonComponent {
  readonly item = input.required<CmdkPersonItem>();
  readonly selected = input(false);
  readonly quickOpenIndex = input<number | null>(null);

  protected readonly initials = computed(() => getInitials(this.item().title));

  protected readonly quickOpenKey = computed(() => {
    const index = this.quickOpenIndex();
    return index === null ? null : String(index + 1);
  });
}
